<template>
  <multiselect-item
    id="idCobranzaLugarDePago"
    track-by="id_cobranza_lugarPago"
    :value="value"
    @input="($event) => $emit('input', $event)"
    :custom-label="
      (option) => `${option.ubicacion_dinero} (${option.id_ubicacion_dinero})`
    "
    placeholder="Seleccione lugar de pago"
    :options="lugarCobranzaOptions"
    :loading="isLoading"
  >
  </multiselect-item>
</template>
<script>
import { get } from "lodash-es";
import AdaptarVueModel from "./AdaptarVueModel";
import axios from "axios";

export default {
  props: ["value"],
  mixins: [AdaptarVueModel],
  mounted() {
    this.getData();
  },
  data: () => ({
    isLoading: true,
    lugarCobranzaOptions: [],
  }),
  methods: {
    async getData() {
      this.isLoading = true;
      try {
        const resp = await axios.post("/execute", {
          method: "CLI.GetLugaresDeCobranza",
          parameters: [],
        });
        if (resp.data.ok) {
          this.lugarCobranzaOptions = get(resp, "data.result[0]", []);
          this.adaptarVueModel(
            this.lugarCobranzaOptions,
            "id_cobranza_lugarPago",
          );
        } else {
          this.$msgBoxOk(resp.data.message);
        }
        this.isLoading = false;
      } catch (e) {
        this.$msgBoxOk(e.toString());
      }
    },
  },
};
</script>
<style scoped></style>
